import { render } from "./TaggingList.vue?vue&type=template&id=6f6eab2d"
import script from "./TaggingList.vue?vue&type=script&lang=js"
export * from "./TaggingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__